export const IMAGE_FILE_URLS_VERSIONS = 'thumbnail,print_a4_optimized';